import type React from "react";
import { useMemo } from "react";
import Button from "~/components/ui/button";
import styles from "./index.module.scss";

// 文字制限の定数
const CHARACTER_LIMITS = {
  organizationName: 50,
};

interface OrganizationFormProps {
  name: string;
  url: string;
  isSaving: boolean;
  onNameChange: (value: string) => void;
  onUrlChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const OrganizationForm: React.FC<OrganizationFormProps> = ({
  name,
  url,
  isSaving,
  onNameChange,
  onUrlChange,
  onSave,
  onCancel,
}) => {
  // 文字数チェック
  const nameCount = useMemo(() => name.length, [name]);

  // 文字数制限を超えているかのチェック
  const hasExceededLimit = useMemo(() => {
    return nameCount > CHARACTER_LIMITS.organizationName;
  }, [nameCount]);

  return (
    <div>
      <form className={styles["content"]}>
        <div className={styles["formField"]}>
          <label>
            組織名
            <span className={styles["required"]}>*</span>
          </label>
          <input
            className={`${styles["inputField"]} ${hasExceededLimit ? styles["exceeded"] : ""}`}
            type="text"
            name="name"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            required
            maxLength={CHARACTER_LIMITS.organizationName}
            data-testid="org-name"
          />
          <div
            className={`${styles["char-counter"]} ${hasExceededLimit ? styles["exceeded"] : ""}`}
          >
            {nameCount}/{CHARACTER_LIMITS.organizationName}
          </div>
        </div>
        <div className={styles["formField"]}>
          <label>会社のURL（任意）</label>
          <input
            className={styles["inputField"]}
            placeholder="詳細を入力してください。空欄可。"
            name="description"
            value={url}
            onChange={(e) => onUrlChange(e.target.value)}
            data-testid="org-url"
          />
        </div>
      </form>
      <div className={styles["buttonContainer"]}>
        <Button label="キャンセル" styleType="white" onClick={onCancel} />
        <Button
          label="保存"
          styleType="blue"
          onClick={onSave}
          disabled={!name.trim() || isSaving || hasExceededLimit}
          dataTestId="org-save"
        />
      </div>
    </div>
  );
};
